import * as React from 'react';

import Pubnub from 'pubnub';

import { useActivityLiveEvent } from './hooks/useActivityLiveEvent';

interface LiveEventsProps {
  roomName: string;
  isRosteredRoom: boolean;
  pubnub: Pubnub;
  activityInstanceId: number;
}

export const ActivityLiveEventListener = (props: LiveEventsProps) => {
  useActivityLiveEvent(props);
  return null;
};

export const ActivityLiveEvent = ({
  isLive,
  ...props
}: LiveEventsProps & { isLive: boolean }) =>
  isLive ? <ActivityLiveEventListener {...props} /> : null;
